import { LitElement, html, css, unsafeCSS } from "lit";
import { styleMap } from "lit/directives/style-map.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export class LavishMomentsSection extends LitElement {
	static properties = {
		activeCell: { type: String, reflect: true },
	};

	constructor() {
		super();
		this.leftCell = null;
		this.rightCell = null;
		this.activeCell = null;

		this.leftCellWatcher = null;
		this.rightCellWatcher = null;
	}

	connectedCallback() {
		super.connectedCallback();

		this.leftCell = this.querySelector(".left-cell");
		this.rightCell = this.querySelector(".right-cell");

		/*const activateLeftCell = () => {
			this.activeCell = "left-cell";
		}.bind(this);

		const activateRightCell = () => {
			this.activeCell = "right-cell";
		}.bind(this);*/

		this.leftCell.addEventListener(
			"mouseenter",
			function () {
				this.activeCell = "left-cell";
			}.bind(this)
		);

		this.rightCell.addEventListener(
			"mouseenter",
			function () {
				this.activeCell = "right-cell";
			}.bind(this)
		);
	}

	createRenderRoot() {
		return this;
	}
}

window.customElements.define("lavish-moments-section", LavishMomentsSection);
